"use client";
import { createContext, useContext } from "react";
const DocumentContext = createContext({
  key: null,
  locale: null
});
function useDocumentContext() {
  return useContext(DocumentContext);
}
function useDocumentKey() {
  return useDocumentContext().key;
}
function useDocumentLocale() {
  return useDocumentContext().locale;
}
export {
  DocumentContext,
  useDocumentContext,
  useDocumentKey,
  useDocumentLocale
};
//# sourceMappingURL=use-document-context.js.map